// Redux.
import { combineReducers } from 'redux';
import { menuItems } from './menuItemsReducer';
import { pageContents } from './pageContentsReducer';

export default combineReducers({
  menuItems,
  pageContents
});
